export const formatDateForDisplay = (dateString) => {
  if (!dateString) return "";

  try {
    // Handle both ISO strings and other formats
    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) return "";

    // Format as DD/MM/YYYY (adjust format as needed)
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  } catch (e) {
    console.error("Error formatting date:", dateString, e);
    return "";
  }
};

// utils/dateFormatter.js

export const formatDateForPopUp = (date) => {
  if (!date) return "";

  // Handle ISO format (2023-12-31)
  if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return date;
  }

  // Handle DD/MM/YYYY format
  if (date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const [day, month, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  // Handle MM/DD/YYYY format
  if (date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const [month, day, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  // Handle Date objects
  if (date instanceof Date) {
    return date.toISOString().split("T")[0];
  }

  // Fallback - try to parse as Date
  try {
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString().split("T")[0];
    }
  } catch (e) {
    console.warn("Could not parse date:", date);
  }

  return "";
};
